// @ts-nocheck
import React, { useState } from 'react';
import { useField, useFormikContext } from 'formik';
import { InputGroup, FormGroup, Intent, Spinner } from '@blueprintjs/core';
import classNames from 'classnames';
import { FormattedMessage as T } from '@/components';
import axios from 'axios';

/**
 * TIN Input component with validation and API integration
 */
export const FTINInput = ({
  name,
  label,
  disabled,
  autoFocus,
  className,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  // Check if there's an error
  const hasError = meta.touched && meta.error;
  const intent = hasError ? Intent.DANGER : Intent.NONE;

  /**
   * Validates TIN number and fetches data from API
   */
  const handleBlur = async (e) => {
    // Call the original onBlur to update Formik's touched state
    field.onBlur(e);

    const tinValue = e.target.value;
    
    // Only proceed if we have a 10-digit TIN number
    if (tinValue && tinValue.length === 10) {
      try {
        setIsLoading(true);
        setApiError(null);
        
        // Make API call to fetch data based on TIN
        const response = await axios.get(`https://apis2.truwrk.com/bizinfo/api/business/${tinValue}`, {headers:{
               accept: 'application/json',
        }});
        // console.log(response.data);
        
        // If API call is successful, update relevant form fields
        if (response.data) {
          console.log(response.data);
          const data = response.data.data;
          
          // Update company name for business types
          if (data.business_name) {
            setFieldValue('company_name', data.business_name);
          }
          
          // Update contact person details if available
          if (data.associates.length > 0) {
            // Extract first and last name from contact person
            const nameParts = data.associates[0].name.split(' ');
            if (nameParts.length > 0) {
              setFieldValue('first_name', nameParts[0]);
              if (nameParts.length > 1) {
                setFieldValue('last_name', nameParts.slice(1).join(' '));
              }
            }

            // Update phone if available
            if (data.associates[0].phone) {
              setFieldValue('work_phone', data.associates[0].phone);
            }

            if (data.associates[0].email) {
              setFieldValue('email', data.associates[0].email);
            }
              
          }
          
      
    
          if (data.business_name) {
            setFieldValue('display_name', data.business_name);
          } 
        }
      } catch (error) {
        console.error('Error fetching TIN data:', error);
        setApiError('Failed to fetch data from TIN');
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <FormGroup
      label={label || <T id={'tin_no'} />}
      className={classNames('form-group--tin_no', className)}
      intent={intent}
      helperText={
        hasError ? meta.error : apiError ? apiError : props.helperText
      }
      {...props}
    >
      <InputGroup
        {...field}
        disabled={disabled || isLoading}
        intent={intent}
        maxLength={10}
        onBlur={handleBlur}
        autoFocus={autoFocus}
        rightElement={isLoading ? <Spinner size={16} /> : null}
        placeholder="0000000000"
      />
    </FormGroup>
  );
}; 